export default __webpack_public_path__ + "static/media/defi.8a8427b3.png";